module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/1/1-c83b00a67df5284d33287a0e049decca.jpg";